<template>
  <div class="page-box">
    <Header />
    <!-- Banner 区 -->
    <div class="top-box">
      <div class="content-positioning">
        <div class="title-1">智慧零售解决方案</div>
        <div class="title-2">零售云 + 巡检机器人，重塑零售运营新模式</div>
        <div class="btn-group">
          <div class="btn-primary">预约演示</div>
          <div class="btn-secondary">立即咨询</div>
        </div>
      </div>
    </div>

    <!-- 行业痛点 -->
    <div class="pain-section">
      <div class="section-title">零售行业面临的挑战</div>
      <div class="pain-grid">
        <div class="pain-item" v-for="(item, index) in painList" :key="index">
          <div class="pain-icon-wrap">{{ index + 1 }}</div>
          <div class="pain-name">{{ item.name }}</div>
          <div class="pain-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>

    <!-- 解决方案 -->
    <div class="solution-section">
      <div class="section-title light">智慧零售整体方案</div>
      <div class="solution-desc light">展示智慧零售方案架构图：前端机器人 + 中台零售云 + 后台数据分析</div>
      <div class="solution-placeholder">
        <div class="placeholder-text">解决方案架构图区域</div>
      </div>
    </div>

    <!-- 核心模块 -->
    <div class="feature-section">
      <div class="section-title">核心模块</div>
      <div class="feature-grid">
        <div class="feature-item" v-for="(item, index) in featureList" :key="index">
          <div class="feature-icon-wrap">{{ index + 1 }}</div>
          <div class="feature-name">{{ item.name }}</div>
          <div class="feature-list">
            <div class="feature-list-item" v-for="(sub, idx) in item.features" :key="idx">
              <span class="check-icon">✓</span>
              <span>{{ sub }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 方案优势 -->
    <div class="advantage-section">
      <div class="section-title">方案核心优势</div>
      <div class="advantage-grid">
        <div class="advantage-card" v-for="(item, index) in advantageList" :key="index">
          <div class="advantage-num">{{ index + 1 }}</div>
          <div class="advantage-content">
            <div class="advantage-name">{{ item.name }}</div>
            <div class="advantage-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 适用场景 -->
    <div class="scene-section">
      <div class="section-title">适用场景</div>
      <div class="scene-table">
        <div class="table-header">
          <div class="th">场景</div>
          <div class="th">说明</div>
          <div class="th">推荐配置</div>
        </div>
        <div class="table-row" v-for="(item, index) in sceneList" :key="index">
          <div class="td name">{{ item.name }}</div>
          <div class="td">{{ item.desc }}</div>
          <div class="td config">{{ item.config }}</div>
        </div>
      </div>
    </div>

    <!-- 客户案例 -->
    <div class="case-section">
      <div class="section-title">客户案例</div>
      <div class="case-carousel">
        <div class="case-item" v-for="(item, index) in caseList" :key="index">
          <div class="case-placeholder">
            <div class="placeholder-text">案例图片</div>
          </div>
          <div class="case-info">
            <div class="case-name">{{ item.name }}</div>
            <div class="case-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 CTA -->
    <div class="cta-section">
      <div class="cta-title">开启智慧零售新篇章</div>
      <div class="cta-desc">立即预约演示，体验智慧零售解决方案带来的增长</div>
      <div class="btn-group">
        <div class="btn-primary">预约演示</div>
        <div class="btn-secondary">立即咨询</div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      painList: [
        { name: '人工成本上涨', desc: '人工成本持续上涨' },
        { name: '运营效率低', desc: '门店运营效率低' },
        { name: '库存管理难', desc: '库存管理不准确' },
        { name: '体验待提升', desc: '顾客体验待提升' },
        { name: '数据驱动弱', desc: '数据驱动能力弱' },
        { name: '融合困难', desc: '线上线下融合难' }
      ],
      featureList: [
        {
          name: '智能巡检',
          features: ['LM200/LM202机器人24h巡检', '商品陈列自动检查', '库存自动盘点', '安防监控']
        },
        {
          name: '门店管理',
          features: ['千橙ERP系统', '千橙收银系统', '员工管理', '排班管理']
        },
        {
          name: '商品管理',
          features: ['商品进销存管理', '价格管理', '促销管理', '供应商管理']
        },
        {
          name: '会员营销',
          features: ['会员管理', '积分管理', '营销活动策划', '精准营销']
        },
        {
          name: '数据分析',
          features: ['销售数据分析', '库存分析', '顾客行为分析', '经营报表']
        }
      ],
      advantageList: [
        { name: '降本增效', desc: '人工成本降低50%，运营效率提升10倍' },
        { name: '数据驱动', desc: '全流程数据采集，智能分析决策' },
        { name: '一体化', desc: '硬件+软件一体化，无缝协同' },
        { name: '易部署', desc: '快速部署，一周上线' },
        { name: '可扩展', desc: '模块化设计，灵活扩展' }
      ],
      sceneList: [
        { name: '大型商超', desc: '大面积巡检、库存盘点', config: 'LM202+零售云全套' },
        { name: '无人零售店', desc: '24h自助运营', config: 'LM200+ERP+收银' },
        { name: '便利店连锁', desc: '标准化运营、集中管理', config: 'LM200+连锁系统' },
        { name: '品牌专卖店', desc: '形象展示、迎宾导购', config: 'LM202+会员营销' },
        { name: '仓储会员店', desc: '库存管理、商品巡检', config: 'LM202+ERP' }
      ],
      caseList: [
        { name: '某大型连锁商超', desc: '引入智慧零售方案后，运营效率提升150%，人力成本降低50%' },
        { name: '某知名无人零售店', desc: '实现24小时无人值守，月均销售额提升30%' },
        { name: '某品牌专卖店', desc: '会员转化率提升80%，客单价提升25%' }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page-box {
  background-color: #fff;
}

/* Banner 区域 */
.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background: linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%);
  display: flex;
  justify-content: center;
  padding-top: 60px;
}

.content-positioning {
  width: 1200px;
  text-align: left;
  padding-top: 120px;
}

.title-1 {
  font-weight: bold;
  font-size: 48px;
  color: #FFFFFF;
  line-height: 60px;
  margin-bottom: 20px;
}

.title-2 {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 36px;
  margin-bottom: 40px;
}

.btn-group {
  display: flex;
  gap: 20px;
}

.btn-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #0EA5E9;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: #F0F9FF;
    transform: translateY(-2px);
  }
}

.btn-secondary {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 50px;
  background: transparent;
  border: 2px solid #FFFFFF;
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

/* 通用区块样式 */
.section-title {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 40px;
  text-align: center;
  margin-bottom: 40px;

  &.light {
    color: #FFFFFF;
  }
}

/* 行业痛点 */
.pain-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #F4F5FB;
}

.pain-grid {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.pain-item {
  width: 380px;
  height: 160px;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
}

.pain-icon-wrap {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  margin-bottom: 15px;
}

.pain-name {
  font-weight: bold;
  font-size: 18px;
  color: #222222;
  line-height: 24px;
  margin-bottom: 10px;
}

.pain-desc {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}

/* 解决方案 */
.solution-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #0EA5E9;
}

.solution-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 26px;
  text-align: center;
  margin-bottom: 40px;

  &.light {
    color: rgba(255, 255, 255, 0.8);
  }
}

.solution-placeholder {
  width: 1200px;
  height: 400px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder-text {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.6);
}

/* 核心模块 */
.feature-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #FFFFFF;
}

.feature-grid {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.feature-item {
  width: 230px;
  background: #F0F9FF;
  border-radius: 12px;
  padding: 30px;
  box-sizing: border-box;
}

.feature-icon-wrap {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 24px;
  color: #FFFFFF;
  margin-bottom: 20px;
}

.feature-name {
  font-weight: bold;
  font-size: 18px;
  color: #222222;
  line-height: 24px;
  margin-bottom: 15px;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feature-list-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #666666;
  line-height: 18px;
}

.check-icon {
  color: #0EA5E9;
  margin-right: 8px;
  font-weight: bold;
}

/* 方案优势 */
.advantage-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #F4F5FB;
}

.advantage-grid {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.advantage-card {
  width: 230px;
  background: #FFFFFF;
  border-radius: 12px;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.advantage-num {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  margin-bottom: 15px;
}

.advantage-name {
  font-weight: bold;
  font-size: 16px;
  color: #222222;
  margin-bottom: 8px;
}

.advantage-desc {
  font-size: 13px;
  color: #666666;
  line-height: 20px;
}

/* 适用场景 */
.scene-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #FFFFFF;
}

.scene-table {
  width: 1200px;
  margin: 0 auto;
  background: #FFFFFF;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #E5E7EB;
}

.table-header {
  display: flex;
  background: #F9FAFB;

  .th {
    padding: 20px;
    font-weight: bold;
    font-size: 16px;
    color: #222222;
    text-align: left;

    &:first-child {
      width: 180px;
    }

    &:last-child {
      flex: 1;
    }
  }
}

.table-row {
  display: flex;
  border-top: 1px solid #E5E7EB;

  .td {
    padding: 20px;
    font-size: 14px;
    color: #666666;
    line-height: 22px;
    text-align: left;

    &:first-child {
      width: 180px;
    }

    &.name {
      font-weight: 500;
      color: #222222;
    }

    &.config {
      flex: 1;
    }
  }
}

/* 客户案例 */
.case-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #F4F5FB;
}

.case-carousel {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 30px;
}

.case-item {
  flex: 1;
}

.case-placeholder {
  width: 100%;
  height: 200px;
  background: #E0E0E0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.case-info {
  padding: 20px;
  background: #FFFFFF;
  border-radius: 0 0 12px 12px;
}

.case-name {
  font-weight: bold;
  font-size: 18px;
  color: #222222;
  margin-bottom: 10px;
}

.case-desc {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}

/* CTA 区域 */
.cta-section {
  width: 100%;
  min-width: 1200px;
  padding: 100px 0;
  background: #FFFFFF;
  text-align: center;
}

.cta-title {
  font-weight: bold;
  font-size: 36px;
  color: #222222;
  margin-bottom: 20px;
}

.cta-desc {
  font-size: 18px;
  color: #666666;
  margin-bottom: 40px;
}
</style>
